import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import PlaceHolder from '../images/happy-clown.png';

const Landing = () => {
  const [gamelist, setGamelist] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  axios.defaults.withCredentials = true;

  useEffect(() => {
    const fetchGameList = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`gamelist?page=${page}`);
        setGamelist(data.data);
        setLastPage(data.meta.last_page);
        setLoading(false);
      } catch (error) {
        setErrorMessage('Failed to load game list. Please try again.');
        setLoading(false);
      }
    };

    fetchGameList();
  }, [page]);

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      {/* Banner */}
      <div
        className="bg-cover bg-center h-64 flex items-center justify-center"
        style={{ backgroundImage: `url(${PlaceHolder})` }}
      >
        <h1 className="text-3xl font-bold bg-black bg-opacity-50 p-4 rounded font-custom tracking-wider">
          Super Fun Games!
        </h1>
      </div>

      {/* Game List */}
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-4">Popular Games</h2>
        {loading ? (
          <p>Loading games...</p>
        ) : errorMessage ? (
          <p className="text-red-500">{errorMessage}</p>
        ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {gamelist.map((game) => (
              <div
                key={game.id}
                className="bg-gray-800 rounded-lg overflow-hidden shadow-lg"
              >
                <Link to={`/gameLoader/${game.short_name}`}>
                  <div className="relative w-full h-48"> {/* Set height explicitly */}
                    <img
                      src={`game-pics/${game.game_pic}`}
                      alt={game.game_title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </div>
                </Link>
                <div className="p-2">
                  <h3 className="text-sm font-medium">{game.game_title}</h3>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Landing;
